import React, { Component } from 'react';
import './ActivityMap.css';
import Map from '../map/Map';

export default class ActivityMap extends Component {
	coords = () => {
		let formattedCoords = [];
		let stockMoveRecords = this.props.coords;
		for (let i in stockMoveRecords) {
			let formatted = stockMoveRecords[i];
			if (!formatted.lat) continue;
			formatted.iconClassName = getIconClass(formatted.stock_move_type__display_name || formatted.record_type);
			formattedCoords.push(formatted);
		}
		return formattedCoords;
	};

	makeIconActive = (id, lat, lon) => {
		this.map.makeIconActive(id, lat, lon);
	};

	render() {
		return (
			<Map
				ref={(ref) => (this.map = ref)}
				onIconClick={this.props.onIconClick}
				coords={this.coords()}
				className="g-activity-map"
			/>
		);
	}
}

let getIconClass = (type) => {
	let options = {
		discrepancy: 'discrepancy',
		un_administer: 'discrepancy',
		waste: 'trash',
		administer: 'check',
		take_ownership: 'check',
		drug_transfer: 'arrow-forward',
		box_transfer: 'arrow-forward'
	};
	return (options[type] || 'calendar') + '-outline-white';
};



// WEBPACK FOOTER //
// ./src/components/activityMap/ActivityMap.jsx